module.exports = __webpack_public_path__ + "static/media/logo_marca.291784b0.png";